<template>
  <v-row justify="center" align="center">
    <v-col cols="12" lg="6" align="center">
      <v-card class="padding-20">
        <v-card-title>Add Administrator</v-card-title>
        <v-subheader v-if="community">Community: {{ community }}</v-subheader>
        <v-card-text class="padding-10">
          <v-form ref="form" lazy-validation>
            <v-autocomplete
              v-model="admin.communityCode"
              :items="communities"
              item-text="name"
              item-value="code"
              label="Community"
              outlined
              required
              :rules="requiredRules"
            ></v-autocomplete>
            <v-text-field
              v-model="admin.email"
              label="email"
              outlined
              required
              :rules="emailRules"
            ></v-text-field>
            <v-row>
              <v-col cols="12" lg="6">
                <v-switch
                  v-model="admin.boardMember"
                  label="HOA Board Member"
                ></v-switch>
              </v-col>
              <v-col cols="12" lg="6">
                <v-switch v-model="admin.super" label="Super"></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="6">
                <v-switch
                  v-model="admin.developer"
                  label="Developer"
                ></v-switch>
              </v-col>
              <v-col cols="12" lg="6">
                <v-switch
                  v-model="admin.towingCompany"
                  label="Towing Company"
                ></v-switch>
              </v-col>
            </v-row>
            <v-alert
              v-if="alert.message != ''"
              :type="alert.type"
              :color="alert.type"
              outlined
              >{{ alert.message }}</v-alert
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="addAdmin">Submit</v-btn>
              <v-btn color="error" text to="/admin">Close</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { adminsRef, communitiesRef } from "../../firebaseApp";
import adminObject from "../json/admin.json";

export default {
  props: ["community", "code"],
  data: () => ({
    admin: adminObject,
    communities: [],
    alert: {
      type: "",
      message: "",
    },
    requiredRules: [(v) => !!v || "This field is required"],
    emailRules: [
      (v) => !!v || "This field is required",
      (v) => /.+@+.+.com/.test(v) || "Email address is not valid",
    ],
  }),
  methods: {
    addAdmin() {
      if (this.$refs.form.validate()) {
        this.admin.dateAdded = Date.now();
        adminsRef.push(this.admin).key;
        this.alert.message = this.admin.email + " has been successfully added";
        this.$refs.form.reset();
        this.alert.type = "success";
      }
    },
    isUnique(prop) {
      let value = this.admin[prop];
      let isUnique = true;
      this.adminsRef.forEach((admin) => {
        if (value == admin.val()[prop]) {
          isUnique = false;
        }
      });
      return isUnique;
    },
  },
  mounted() {
    communitiesRef.on("value", (snap) => {
      snap.forEach((community) => {
        this.communities.push(community.val());
      });
    });
  },
};
</script>